import axios from 'axios'
import {message, Modal, notification} from 'ant-design-vue'
import moment from 'moment'
import store from '../store'
import db from 'utils/localstorage'
moment.locale('zh-cn')

// 统一配置
let FEBS_REQUEST = axios.create({

  baseURL: '/onlinecarback/',  //这里配置了后端接口前缀，在Nginx中配置，转发
  //baseURL: 'http://localhost:9091/onlinecarback/',
  // baseURL:'/onlinecar/onlinecarback/', //onlinecar是zuul的前缀，配置方便zuul转发，onlinecarback是后端接口前缀
  responseType: 'json',
  validateStatus(status) {
    // 200 外的状态码都认定为失败
    return status === 200
  }
})


// 拦截请求
FEBS_REQUEST.interceptors.request.use((config) => {
  //如果不转化jsonString,打印出来会是Object类型。
  //console.log('拦截请求（成功）：'+JSON.stringify(config))
  let expireTime = store.state.account.expireTime
  let now = moment().format('YYYYMMDDHHmmss')
  // 让token早10秒种过期，提示“请重新登录”弹窗体验
  if (now - expireTime >= -10) {
    Modal.error({
      title: '登录已过期',
      content: '很抱歉，登录已过期，请重新登录',
      okText: '重新登录',
      mask: false,
      onOk: () => {
        return new Promise((resolve, reject) => {
          db.clear()
          location.reload()
        })
      }
    })
  }
  // 有 token就带上
  if (store.state.account.token) {
    config.headers.Authentication = store.state.account.token
  }
  //请求头中的Status Code: 302 就是帐号在其他地方登录了，后端直接拒绝请求
  //TODO

  return config
}, (error) => {
  console.log('拦截请求（失败）：'+JSON.stringify(error))
  return Promise.reject(error)
})

// 拦截响应
FEBS_REQUEST.interceptors.response.use((config) => {
  //console.log("拦截响应结果："+JSON.stringify(config));
  //如果帐户在另一处登录，后端定义状态码：301006
  if(config.data.code==="301006"){
    this.$message.warning(config.data.msg)
    db.clear()
    this.$router.push({
      path: "/login",
    });
  }
    return config

}, (error) => {
  if (error.response) {
   // console.log("拦截器响应error.response："+error.response);
    let errorMessage = error.response.data === null ? '系统内部异常，请联系网站管理员' : error.response.data.message
    switch (error.response.status) {
      case 302:
        notification.warn({
          message: '系统提示',
          description: '帐户登录异常，请退出重新登录',
          duration: 4
        })
        break;
      case 404:
        notification.error({
          message: '系统提示',
          description: '很抱歉，资源未找到',
          duration: 4
        })
        break
      case 403:
      case 401:
        notification.warn({
          message: '系统提示',
          description: '很抱歉，您无法访问该资源，可能是因为没有相应权限或者登录已失效',
          duration: 4
        })
        break
      default:
        notification.error({
          message: '系统提示',
          description: errorMessage,
          duration: 4
        })
        break
    }
  }
  return Promise.reject(error)
})



const request = {
  post (url, params) {
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        // 'content-type': 'application/json;charset=UTF-8',
        'Source':'mgr'
      }
    })
  },

  //content-type为json格式的post请求
  postJSON (url, params) {
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      headers: {
        //   'Content-Type': 'application/x-www-form-urlencoded',
       'Content-type': 'application/json;charset=UTF-8',
        'Source':'mgr'
      }
    })
  },

  postMultipart (url, params) {
    return FEBS_REQUEST.post(url, params, {
      headers: {
        'Content-type': "multipart/form-data",
        'Source':'mgr'
      }
    })
  },

  put (url, params) {
    return FEBS_REQUEST.put(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Source':'mgr'

      }
    })
  },
  get (url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return FEBS_REQUEST.get(`${url}${_params}`,{
      headers: {
        'Source':'mgr'
      }
    })
  },


  delete (url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return FEBS_REQUEST.delete(`${url}${_params}`,{
      headers: {
        'Source':'mgr'
      }
    })
  },
  export (url, params = {},fileName) {
    message.loading('导出数据中,数据量较大请稍等~ ~ ~')
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      responseType: 'blob',
      headers: {
        'Source':'mgr'
      }
    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      //const fileName = `${new Date().getTime()}_导出结果.xlsx`
      let filename =`${fileName}_导出结果.xlsx`
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = filename
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, fileName)
      }
      if(filename==="订单信息_导出结果.xlsx"){
        this.$store.dispatch("constants/saveOrderExportFlag",false);
      }
    }).catch((r) => {
      console.error(r)
      message.error('导出失败')
    })
  },
  download (url, params, filename) {
    message.loading('文件传输中')
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      responseType: 'blob',
      headers: {
        'Source':'mgr'
      }

    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = filename
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, filename)
      }
    }).catch((r) => {
      console.error(r)
      message.error('下载失败')
    })
  },
  upload (url, params) {
    return FEBS_REQUEST.post(url, params, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Source':'mgr'
      }
    })
  },

  //司机车辆模板下载专用（模板为做好的excel表格，非代码生成）
  modelDownload(url,fileName){
    return FEBS_REQUEST.get(url,{
      responseType: 'blob',  //接收类型设置，否者返回字符型
      headers: {
        'Source':'mgr'
      }
    }).then((res)=>{
      let data=res.data;
      if (!data){
        return;
      }
      const  blob=new Blob([data],{
        //type: "application/vnd.ms-excel" 这一句代码,是下载excel表格需要的,下载txt文件则不需要这句,这是和下载txt文件 前端唯一的区别
        type: "application/vnd.ms-excel",

      })
      if (window.navigator.msSaveOrOpenBlob){ // 兼容IE10
        navigator.msSaveBlob(blob,fileName);
      }else { // 其他非IE内核支持H5的浏览器
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click()
      }
    }).catch((error)=>{
      this.$message.error(error);
    })
  },

  //司机 车辆信息导入
  modelUpLoad(event,url) {
    if(this.file == null){
      alert("文件为空,请选择文件进行导入");
    }else {
      //阻止元素发生默认的行为
      event.preventDefault();
      let formData = new FormData();
      formData.append("file", this.file);
      return FEBS_REQUEST.post(url,formData,{
        headers: {
          'Source':'mgr',
          // 'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if(response.data.code ===0){
          alert(response.data.data);
          //上传成功后，刷新数据
          // this.getData(this.pageNum,this.pageSize);
          // this.getData(this.pageNum,this.pageSize)
        }else {
          alert(response.data.msg);
        }
      }).catch(function (error) {
        alert(error);
        // console.log(error.message);

      });
    }
  },


}



export default request



// WEBPACK FOOTER //
// ./src/utils/request.js